import * as THREE from 'three';

import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import Stats from 'three/examples/jsm/libs/stats.module'
import { DataManager } from '../data/DataManager';
import { MojisLines } from '../moji/MojisLines';
import { MojiPointsUtil } from '../moji/utils/MojiPointsUtil';
import { ObjLoaders } from '../data/ObjLoaders';
import { LogoMark } from '../moji/logo/LogoMark';
import { Timeline } from './Timeline';
import { MatManager } from '../data/MatManager';
import { DomControl } from './DomControl';
import { ScreenSize } from '../data/ScreenSize';
import { ITimeline } from '../data/Params';
import { TimelineSub } from './TimelineSub';


export class Main{

    renderer:THREE.WebGLRenderer;
    scene:THREE.Scene;
    camera:THREE.OrthographicCamera
    bgColor:{color:number};
    stats:Stats;
    light:THREE.DirectionalLight;
    controls:OrbitControls;
    mojis:MojisLines;
    logoMark:LogoMark;
    dataManager:DataManager;
    matManager:MatManager;
    
    objLoaders:ObjLoaders;
    zoomScale:number=0.55;
    timeline:ITimeline;
    domControl:DomControl;


    init(){

        //window.alert( document.getElementById("mvScript").dataset.mode );

        this.renderer = new THREE.WebGLRenderer({
            canvas: document.querySelector('#webgl'),
            antialias: false
        });
        this.renderer.setPixelRatio(1);
        this.bgColor = {color:0x000000};
        let bgCol = new THREE.Color(this.bgColor.color);
        this.renderer.setClearColor(bgCol);
        this.renderer.setSize(window.innerWidth,window.innerHeight);

        this.loadObj();
    }

    loadObj(){
        this.dataManager = DataManager.getInstance();
        this.dataManager.init();

       this.domControl = new DomControl();
       this.domControl.init();
       
       MojiPointsUtil.init();
       this.objLoaders = new ObjLoaders();
       this.objLoaders.load(()=>{
            //this.logo = this.objLoaders.list[0].mesh;
            this.start();
       });

       window.addEventListener('resize', ()=>{
        this.onWindowResize();
        }, false);      
       this.onWindowResize();

    }

    start(){

        this.scene = new THREE.Scene();
        
        this.matManager=MatManager.getInstance();

        this.dataManager.logo = this.objLoaders.list[0].mesh;
        this.dataManager.logo2 = this.objLoaders.list[2].mesh;
        this.dataManager.dom=this.domControl;
        this.dataManager.scene = this.scene;

        this.camera = new THREE.OrthographicCamera(
            -window.innerWidth,window.innerWidth,
            window.innerHeight,-window.innerHeight
        );
        this.camera.position.set(0,0,700); 

        this.dataManager.gui?.addColor(this.bgColor,"color").onChange((value:number)=>{
            this.renderer.setClearColor(new THREE.Color(value as number));
        });

        this.light = new THREE.DirectionalLight(0xffffff);
        this.light.position.set(5,-10,10);
        this.scene.add(this.light); 
 
        const light2:THREE.AmbientLight = new THREE.AmbientLight(0x555555);
        this.scene.add(light2);
       
        //this.controls = new OrbitControls(this.camera, this.renderer.domElement);
       
        this.startAnim();
        this.onWindowResize();
    }


    startAnim(){
        this.mojis = new MojisLines();
        this.mojis.init();
        this.scene.add( this.mojis );

        this.dataManager.camera = this.camera;
        this.dataManager.mojis = this.mojis;

        this.logoMark = new LogoMark();
        this.logoMark.init(this.objLoaders.list[1].mesh);
        this.scene.add(this.logoMark);

        this.dataManager.logoMark = this.logoMark;

        if( this.dataManager.IsTopMode()){
            this.timeline = new Timeline();
        }else{
            this.timeline = new TimelineSub();
        }

        this.timeline.start();

        // 毎フレーム更新関数を実行
        this.tick();        
    }


    tick(){

        if(window.scrollY<window.innerHeight*0.9){
            
            this.mojis?.update();
            this.logoMark?.update();
            // 描画
            this.renderer.render(this.scene, this.camera);
            this.controls?.update();
            this.dataManager?.update();    
            this.domControl?.update();

        }
        //loop
        //window.requestAnimationFrame(()=>{
        //    this.tick();
        //});        
        setTimeout(()=>{
            this.tick();
        },1000/60)
    }


    onWindowResize(){

        this.domControl?.resize();
        
        if(this.camera){
        
            ScreenSize.ResizeCamera(this.camera);

            this.logoMark.resize();
            this.mojis.resize();

            this.camera.updateProjectionMatrix()
            this.renderer.setSize(
                //window.innerWidth, 
                document.body.clientWidth,
                window.innerHeight
            );

        }
        
    }

}